import { render, staticRenderFns } from "./iFeelReportCopy.vue?vue&type=template&id=54d6f934&scoped=true&"
import script from "./iFeelReportCopy.vue?vue&type=script&lang=js&"
export * from "./iFeelReportCopy.vue?vue&type=script&lang=js&"
import style0 from "./iFeelReportCopy.vue?vue&type=style&index=0&id=54d6f934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d6f934",
  null
  
)

export default component.exports